module.exports = "pegasus/assets/hexagon-twitter-old.png";